/* eslint-disable indent */
/* eslint-disable semi */
import React, { useEffect, useState } from 'react'
import { Grid, Button, Typography } from '@material-ui/core/'
import moment from 'moment'
import './index.scss'

const CardTemplate = ({ uuid, name, date, deleteTemplate, getTemplateById }) => {
  const [visible, setVisible] = useState(false)
  const addedDeleteBtn = () => {
    switch (name) {
      case 'Account story ban':
        setVisible(false)
        break;
      case 'Account meeting ban':
        setVisible(false)
        break;
      case 'Story ban':
        setVisible(false)
        break;
      case 'Feedback form':
        setVisible(false)
        break;
      case 'First story':
        setVisible(false)
        break;
      case 'Welcome email':
        setVisible(false)
        break;
      default:
        setVisible(true)
        break;
    }
  }

  useEffect(() => {
    addedDeleteBtn()
  }, [name])
  return (
    <Grid className='CardTemplate'>
      <Grid className='boxCardTemplate' onClick={() => getTemplateById(uuid, 2)}>
        <Typography className='dateTemplate'>{moment(date).format('L')}</Typography>
        <Typography className='nameTemplate'>{name}</Typography>
        <Typography className='deskTemplate'>Greyhound divisively hello coldly wonderfully marginally...</Typography>
      </Grid>
      <Grid>
        {visible && (
          <Button className='deleteTemplate' onClick={() => deleteTemplate(uuid)}>DELETE</Button>
        )}
        <Grid className='boxCardBtn'>
          <Button className='editTemplate' onClick={() => getTemplateById(uuid, 1, true)}>Copy</Button>
          <Button className='editTemplate' onClick={() => getTemplateById(uuid, 1)}>EDIT</Button>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CardTemplate
